import { render, staticRenderFns } from "./ReferenciaNueva.vue?vue&type=template&id=341d9de2&"
import script from "./ReferenciaNueva.vue?vue&type=script&lang=js&"
export * from "./ReferenciaNueva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports